import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackDashboardGlobalFilterEvents = createAnalyticsTracker(
  'dashboardGlobalFilter',
);
